import { Component, OnInit, Input } from '@angular/core';
import { AngularFirestore } from '@angular/fire/firestore';
import { Observable, Subject } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-summary',
  templateUrl: './summary.component.html',
  styleUrls: ['./summary.component.css']
})
export class SummaryComponent implements OnInit {
  summary: Observable<any[]>;
  @Input() playerId;

  constructor(private firestore: AngularFirestore, private route: ActivatedRoute) {
  }

  ngOnInit() {
    this.summary = this.firestore.collection('players', ref => ref.where('ID', '==', this.playerId)).valueChanges();
  }

  getPlayerAttributes() {
    return "/assets/images/attributes/" + this.playerId.toString() + ".PNG";  
  }

  hideAttributes(event) {
    event.target.outerHTML = "<p>N/A</p>";
    document.getElementById("attributes-link").removeAttribute("href");
  }
}
